export const copyStylesAndScripts = (iframe: HTMLIFrameElement) => {
  const doc = iframe.contentDocument;
  //@ts-expect-error doc всегда есть
  const head = doc.head;

  // Копируем стили
  document.querySelectorAll('style, link[rel="stylesheet"]').forEach(style => {
    head.appendChild(style.cloneNode(true));
  });

  // Копируем скрипты
  document.querySelectorAll('script').forEach(script => {
    // @ts-expect-error doc всегда есть
    const newScript = doc.createElement('script');
    newScript.textContent = script.textContent;
    head.appendChild(newScript);
  });
};
